export const THEME_PALETTE = {
  gray: "#F4F4F4",
  green: "#6A983C",
  green_200: "#F4F8EC",
  green_700: "#46760A",
  black: "#151515;",
  gray_400: "#F9F9F9",
  gray_500: "#D1D1D1",
  gray_600: "#A9A9A9",
  gray_700: "#7e7e7e",
  red_500: "#dc3545",
  red_700: "#b02a37",
};
